(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seaflo-header"] && !Shopify.designMode) return;
  try {
    
  class SfdNavigation extends HTMLElement {
    connectedCallback(){
      this.menu=this.querySelector('.sfd-menu');
      this.media=window.matchMedia('(min-width:750px)');
      this.resize=()=>{this.menu.open=this.media.matches};
      this.resize();this.media.addEventListener('change',this.resize);
      this.keydown=(e)=>{if(e.key==='Escape'){const open=this.querySelector('.sfd-submenu[open]');if(open){open.open=false;open.querySelector('summary').focus()}else if(!this.media.matches){this.menu.open=false;this.menu.querySelector('summary').focus()}}};
      this.addEventListener('keydown',this.keydown);
      this.align=(e)=>{const panel=e.target;if(!panel.matches('.sfd-submenu')||!panel.open)return;for(const other of this.querySelectorAll('.sfd-submenu[open]')){if(other!==panel)other.open=false}const list=panel.querySelector('.sfd-submenu__list');list.style.transform='';if(this.media.matches){const rect=list.getBoundingClientRect();let offset=0;if(rect.right>innerWidth-16)offset=innerWidth-16-rect.right;if(rect.left+offset<16)offset=16-rect.left;list.style.transform=`translateX(${offset}px)`}};
      this.addEventListener('toggle',this.align,true);
      this.outside=(e)=>{if(!this.contains(e.target)){for(const open of this.querySelectorAll('.sfd-submenu[open]'))open.open=false}};
      document.addEventListener('click',this.outside);
    }
    disconnectedCallback(){this.media?.removeEventListener('change',this.resize);this.removeEventListener('keydown',this.keydown);this.removeEventListener('toggle',this.align,true);document.removeEventListener('click',this.outside)}
  }
  if(!customElements.get('sfd-navigation'))customElements.define('sfd-navigation',SfdNavigation);

  } catch(e) { console.error(e); }
})();
})();
